import type { Building } from "building-types/building/buildingTypes";
import { evalFormulas, resolveOptionsInFormula } from "doc/formula/evalFormulas";
import { removeDisabledEntities } from "../generationTools/generateSheetsTools";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

type SelectReturnType = ReturnType<typeof select>;

function select({
  doc: { sheets, drawingRefs, optionSets, instanceOptionSets },
  optionChoices,
  entityDisabledByGroup,
}: Pick<Building, "doc" | "optionChoices" | "entityDisabledByGroup">) {
  const definitions = { optionSets, instanceOptionSets };
  return {
    sheets,
    drawingRefs,
    optionSets,
    optionChoices: resolveOptionsInFormula({ sheets, drawingRefs }, definitions, optionChoices),
    entityDisabledByGroup,
  };
}

const compare = makeGenerationStageComparator<typeof select>({
  optionChoices: "shallow",
});

function generate({
  sheets,
  optionChoices,
  drawingRefs,
  entityDisabledByGroup,
}: SelectReturnType): Pick<SelectReturnType, "sheets" | "drawingRefs"> {
  sheets = evalFormulas(sheets, (id) => optionChoices[id], undefined, entityDisabledByGroup);
  sheets = removeDisabledEntities(sheets);
  drawingRefs = evalFormulas(drawingRefs, (id) => optionChoices[id]);
  drawingRefs = removeDisabledEntities(drawingRefs);

  return { sheets, drawingRefs };
}

export default memo(select, generate, compare);
